import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./footer.css";

export default class Footer extends React.Component {
  render() {
    return (
      <div class="footer">
        <h5>© 2023 FirstFloor Studios</h5>

        <ol>
          <li class="footer-links"> Products </li>
          <Link to="/" class="footer-link">
            <li> FirstFloor </li>
          </Link>
          <Link to="/RoomService" class="footer-link">
            <li> RoomService </li>
          </Link>
        </ol>

        <ol>
          <li class="footer-links"> Socials </li>
          <a
            href="https://twitter.com/firstfloorapp"
            target="_blank"
            class="footer-link"
          >
            {" "}
            <li> Twitter </li>
          </a>
          <a
            href="https://discord.gg/nm4xRx42ww"
            target="_blank"
            class="footer-link"
          >
            {" "}
            <li> Discord </li>{" "}
          </a>
        </ol>
      </div>
    );
  }
}
